import { useTranslation } from "react-i18next";

interface HeadingTextProps {
  categoryCount: number;
  questionCount: number;
}

function HeadingText({ questionCount }: HeadingTextProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <div className="text-lg font-bold sm:text-2xl">
        {t("simple-assessment")}
      </div>

      <span>
        全 {questionCount} {t("question-counter")}
      </span>
    </div>
  );
}

export default HeadingText;
